<div>
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>

  <div class="invoice-table-container">
    <ag-grid-angular
      style="width: 100%; height: 100%"
      class="ag-theme-alpine"
      rowSelection="multiple"
      rowHeight="48"
      ensureDomOrder="true"
      suppressRowClickSelection="true"
      enableCellTextSelection="false"
      enableRangeSelection="true"
      suppressContextMenu="true"
      suppressDragLeaveHidesColumns="true"
      suppressMenuHide="true"
      [icons]="customIcons"
      [columnDefs]="columnDefs"
      [tooltipShowDelay]="500"
      [defaultColDef]="defaultColDef"
      [paginationPageSize]="paginationPageSize"
      [pagination]="true"
      [suppressPaginationPanel]="true"
      [suppressCellSelection]="true"
      [getMainMenuItems]="getMainMenuItems"
      [suppressScrollOnNewData]="true"
      [rowData]="rowData"
      [domLayout]="domLayout"
      (columnMoved)="onColumnMoved($event)"
      (columnResized)="onColumnResized($event)"
      (rowSelected)="onRowSelected()"
      (columnVisible)="onColumnVisible()"
      (sortChanged)="onSortChange($event)"
      (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>

  <div class="d-flex justify-content-between align-items-center my-15 has-pagination">
    <div class="pagination-left">
      <app-pagination
        *ngIf="totalRowsCount > paginationPageSize"
        [totalItems]="totalRowsCount"
        [(currentPage)]="currentPageNumber"
        (change)="onPageChange($event)"
        [pageSize]="paginationPageSize"></app-pagination>
    </div>

    <div class="d-flex align-items-center justify-content-end pagination-right">
      <span class="pagination-count"
        >Showing {{ totalRowsCount > paginationPageSize ? paginationPageSize : totalRowsCount }} of {{ totalRowsCount }} results</span
      >
      <ul *ngIf="sizes.length" class="pagination">
        <li *ngFor="let size of sizes" [ngClass]="{ active: size === paginationPageSize }">
          <a tabindex="0" (keyup.enter)="changeSize($event, size)" (click)="changeSize($event, size)">{{ size }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #deleteModalTpl let-dialogRef="dialogRef">
  <deletemodal [dialogRef]="dialogRef"></deletemodal>
</ng-template>
